import React, { useCallback, useRef, useState } from 'react';

import * as Yup from 'yup';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import api from 'services/api';
import { useNotices } from 'hooks';
import { IResponse } from 'store/modules/common-types';
import getValidationErrors from 'utils/getValidationErrors';

import Button from 'components/common/Button';
import Input from 'components/common/Input';

import * as S from './styles';

interface IFormData {
  name: string;
  email: string;
}

const NewsLetter: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { addNotices } = useNotices();

  const [isValid, setIsValid] = useState(false);

  const handleValidateForm = useCallback(
    async e => {
      const formData = formRef.current.getData();

      const schema = Yup.object().shape({
        name: Yup.string()
          .max(200, 'Nome muito extenso.')
          .required('Campo obrigatório.'),
        email: Yup.string()
          .max(100, 'E-mail muito extenso.')
          .email('E-mail inválido')
          .required('Campo obrigatório.'),
      });

      try {
        await schema.validate(formData, { abortEarly: false });

        setIsValid(true);
      } catch (err) {
        setIsValid(false);
      }
    },
    [formRef],
  );

  const handleSubmit = useCallback(
    async (data: IFormData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string()
            .max(200, 'Nome muito extenso.')
            .required('Campo obrigatório.'),
          email: Yup.string()
            .max(100, 'E-mail muito extenso.')
            .email('E-mail inválido')
            .required('Campo obrigatório.'),
        });

        await schema.validate(data, { abortEarly: false });

        const response = await api.post<IResponse>('/newsletter', {
          email: data.email,
          nome: data.name,
        });

        if (!response.data.contemAvisos && !response.data.contemErros) {
          addNotices({
            messages: ['Seu e-mail foi cadastrado com sucesso!'],
            type: 'allMessages',
          });
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }
      }
    },
    [addNotices],
  );

  return (
    <S.Container className="footer-background-new-letter">
      <div className="footer-new-letter">
        <div className="footer-new-letter-info">
          <img
            src="/images/icons/mail-green.svg"
            alt="Email"
            className="icon mail-icon"
          />

          <span>Receba as melhores promoções no seu e-mail!</span>
        </div>

        <Form
          onSubmit={handleSubmit}
          ref={formRef}
          onChange={handleValidateForm}
        >
          <Input name="name" placeholder="seu nome..." />

          <Input name="email" placeholder="seu e-mail..." />

          <Button type="submit" disabled={!isValid}>
            Enviar
          </Button>
        </Form>
      </div>
    </S.Container>
  );
};

export default NewsLetter;
